<template>
  <div>
    <input
      type="text"
      class="form-control form-control-sm e2e-text-field"
      v-mc-validate="validatorArgs"
      :style="{'max-width': width, 'min-width': width}"
      v-model="value"
      :placeholder="fragment.placeholder"
      :name="fragment.uuid"
      :readonly="!fragment.editable"
    >

    <div
      v-if="validationErrorMessage"
      class="invalid-feedback text-right"
    >{{validationErrorMessage}}</div>
  </div>
</template>

<script> 
export default {
  name: "fragment-text-field",
  props: ["fragment"],
  data: function() {
    return {
      validationErrorMessage: null,
      value: null
    };
  }, 
  methods: {
    onValidationChanged({ errorMessage }) {
      this.validationErrorMessage = errorMessage;
    }
  },
  mounted() {
    this.value = this.fragment.initialValue;
  },
  computed: {
    validatorArgs() { 
      let fragment = this.fragment;
      return {
        expect: "text-from-input", 
        regex: fragment.regex ? fragment.regex : null,
        regexErrorMessage: fragment.regexErrorMessage ? fragment.regexErrorMessage : null,
        allowNoValue: this.fragment.allowNoValue,
        onValidationChanged: this.onValidationChanged, // callback
        semanticValidation: {
          invalid: this.fragment.semanticInvalid,
          validatedValue: this.fragment.initialValue,
          message: this.fragment.semanticInvalidMessage
        }
      };
    },
    width() {
      if (this.fragment.widthPixel) {
        return `${this.fragment.widthPixel}px`;
      }
      return "initialValue";
    }
  }
};
</script>
 

<style scoped>
</style>